module.exports = "<p>\n  progress works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tooltip/progress/progress.component.html
// module id = ./src/app/tooltip/progress/progress.component.html
// module chunks = main